<template>
  <section>
    <div v-if="false">
      <section style="height: 100%" class="d-flex align-items-center pb-1">
        <stacked-bar-graph :styles="myStyles" :data="videoData" />
        <stacked-bar-graph :styles="myStyles" :data="commentData" />
      </section>
    </div>
    <div class="">
      <table class="table">

      <tr>
        <th>User</th>
        <th>Videos Uploaded</th>
        <th data-tippy-arrow="true" data-tippy="Total duration of uploaded videos">Total Video Duration (h:mm:ss)</th>
        <th data-tippy-arrow="true" data-tippy="Avg duration of uploaded videos">Avg Video Duration (h:mm:ss)</th>
        <th data-tippy-arrow="true" data-tippy="Number of your videos that you have shared">Shared Videos</th>
        <th data-tippy-arrow="true" data-tippy="Number of comments you added across any video">Comments</th>
      </tr>

      <tr v-for="u in data">
        <td>{{ u.User }}</td>
        <td>{{ u.Videos }}</td>
        <td>{{ u.Duration }}</td>
        <td>{{ u['Avg Duration'] }}</td>
        <td>{{ u['Shared Videos'] }}</td>
        <td>{{ u.Comments }}</td>
      </tr>

    </table>
    </div>
  </section>
</template>

<script>
import StackedBarGraph from './StackedBarGraph.vue'

const colors = [
  '#f3a683',
  '#f5cd79',
  '#778beb',
  '#e77f67',
  '#f8a5c2',
  '#f19066',
  '#786fa6',
  '#cf6a87',
  '#596275',
  '#574b90',
  '#e66767',
  '#303952'
]

export default {
  name: 'DataPane',
  components: {
    'stacked-bar-graph': StackedBarGraph,
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    data: {
      type: Array,
      required: true,
    },
  },
  data () {
    return {
      videoData: {
        labels: ['Videos'],
        datasets: [
          {
            label: 'Alex',
            data: [2],
            backgroundColor: colors[0],
          },
          {
            label: 'Alison',
            data: [2],
            backgroundColor: colors[6],
          },
          {
            label: 'Sarah',
            data: [5],
            backgroundColor: colors[2],
          }
        ],
      },
      commentData: {
        labels: ['Comments'],
        datasets: [
          {
            label: 'Alex',
            data: [67.8],
            backgroundColor: colors[0],
          },
          {
            label: 'Alison',
            data: [20.7],
            backgroundColor: colors[6],
          },
          {
            label: 'Sarah',
            data: [11.4],
            backgroundColor: colors[2],
          }
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false
      },
      loaded: false,
    }
  },
  computed: {
    myStyles () {
      return {
        width: '500px',
        height: '250px',
      }
    }
  },
  mounted () {
    this.fillData()
    this.loaded = true
  },
  methods: {
    fillData () {
      this.datacollection = {
        labels: [this.getRandomInt(), this.getRandomInt()],
        datasets: [
          {
            label: 'Data One',
            backgroundColor: '#f87979',
            data: [this.getRandomInt(), this.getRandomInt()]
          }, {
            label: 'Data One',
            backgroundColor: '#f87979',
            data: [this.getRandomInt(), this.getRandomInt()]
          }
        ]
      }
    },
    getRandomInt () {
      return Math.floor(Math.random() * (50 - 5 + 1)) + 5
    }
  }
}
</script>

<style lang="scss" scoped>
.d-flex {
  display: flex;
}

.align-items-center {
  align-items: center;
}

img {
  width: 80px;
  height: 80px;
  border-radius: 5px;
}

.pr-1 {
  margin-right: 1rem;
}

.pb-1 {
  margin-bottom: 1rem;
}

@media screen and (max-width: 500px) {
    .image {
        display: none !important;
    }

    .title {
      font-size: 1rem;
    }
}

</style>



// WEBPACK FOOTER //
// DataPane.vue?686062fe